import {addToCartHandler} from "./addToCart";
import axios from "axios";
import {toggleAddedToCart} from "./added-to-cart";


const upsellForms = [...document.querySelectorAll('.js-product-add-form')];
upsellForms.map(upsellForm => {
    upsellForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        const openMicrocart = upsellForm.dataset.microcart === 'true' ? true : false;

        // Wait for addToCartHandler to complete
        await addToCartHandler(e, 1, openMicrocart);

        // Then execute updateCart
        await updateCart();
    });

    const updateCart = async () => {
        try {
            const response = await axios.post(`${window.Shopify.routes.root}cart/update.js`);
            console.log('success');


            if (response.status === 200) {
                if (upsellForm.dataset.type === 'ajax') {
                    toggleAddedToCart();
                } else {
                    document.body.style.opacity = .3;
                    location.reload();
                }
            }
        } catch (error) {
            console.error('Error updating cart:', error);
        }
    }

});

